import { render, staticRenderFns } from "./InvitationSelectionButton.vue?vue&type=template&id=660c861c&scoped=true&"
import script from "./InvitationSelectionButton.vue?vue&type=script&lang=js&"
export * from "./InvitationSelectionButton.vue?vue&type=script&lang=js&"
import style0 from "./InvitationSelectionButton.vue?vue&type=style&index=0&id=660c861c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660c861c",
  null
  
)

export default component.exports